import { render, staticRenderFns } from "./EnviarNotificacao.vue?vue&type=template&id=2ae1ec18&"
import script from "./EnviarNotificacao.vue?vue&type=script&lang=js&"
export * from "./EnviarNotificacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports